import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import type { PeriodPermissions } from '../policies/period-actions.policy';

/** What the signed-in user may do with accounting periods. Hiding what they can't is UX only; the server decides. */
export function usePeriodPermissions(): PeriodPermissions {
  const { state } = useCurrentUser();
  const permissions = state.status === 'authenticated' ? state.user.permissions : [];
  return {
    canManage: permissions.includes('period.manage'),
    canLock: permissions.includes('period.lock'),
    canUnlock: permissions.includes('period.unlock'),
  };
}
